module.exports = __webpack_public_path__ + "static/media/sf_2800.e70a7eb68e835072690939203f99735d.png";